import React from "react"
import {useModal} from "react-modal-hook"
import {TagsViewerKeyValue} from "./TagsViewer"
import Icon from "../Icon/Icon"
import EditTagsModal from "./EditTagsModal"
import classNames from "classnames"
import {Result} from "neverthrow"
import {ErrorDocument} from "../../resources/common"

interface TagsCardProps {
	tags: {[key: string]: string}
	onUpdateTags?: (accessToken: string, tags: {[key: string]: string | null}) => Promise<Result<unknown, ErrorDocument>>
	refresh?: () => void
	editable?: boolean
	className?: string
}

export default function TagsCard({tags, onUpdateTags, refresh, editable = true, className}: TagsCardProps) {
	const canEdit = editable && onUpdateTags && refresh

	const [showEditModal, hideEditModal] = useModal(
		() =>
			canEdit ? (
				<EditTagsModal originalTags={tags} close={hideEditModal} refresh={refresh} updateTags={onUpdateTags} />
			) : null,
		[tags, refresh, onUpdateTags, canEdit]
	)

	const hasTags = Object.keys(tags).length > 0

	return (
		<div className={classNames("card tags-card", className)}>
			<div className="card-header">
				<p className="card-header-title">Tags</p>
				{canEdit && (
					<button type="button" className="tags-card-edit-button" onClick={showEditModal} aria-label="Edit tags">
						<Icon icon="pencil-1--interface-essential" size={16} />
					</button>
				)}
			</div>
			<div className="card-content">
				{hasTags ? <TagsViewerKeyValue tags={tags} /> : <p className="has-text-grey-light">No tags</p>}
			</div>
		</div>
	)
}
